// extracted by mini-css-extract-plugin
module.exports = {"item-container":"Tab_item-container__xNDIj","active-item":"Tab_active-item__xIQiW"};